// extracted by mini-css-extract-plugin
export default {"borderedFooter":"AnsweredCommentsContainer-borderedFooter-2bb83dbc19efdba2acec67d3efc3e28b"};